import { compose, lifecycle, withState, withHandlers } from 'recompose';
import { connect } from 'react-redux';

import View from './Components';

export default compose(
  connect(
    state => ({}), { },
  ),
)(View);